import { useSelector } from 'react-redux';

import { selectFooterLayout } from '../../../selectors/footerLayout';
import { selectLayoutType } from '../../../selectors/layoutType';
import { TLayoutType } from '../../../types/layoutType';
import { IFooterLayoutConfiguration } from '../../../types/footerLayout';
import { DeepPartial } from '../../../types/deepPartial';

type TLayoutConfiguration = DeepPartial<{
  type: TLayoutType;
  footer: IFooterLayoutConfiguration;
}>;

export function useLayoutConfiguration(): TLayoutConfiguration {
  const layoutType = useSelector(selectLayoutType);
  const footerLayout = useSelector(selectFooterLayout);

  const layoutConfiguration: TLayoutConfiguration = {
    type: layoutType,
  };

  if (footerLayout) {
    layoutConfiguration.footer = footerLayout;
  }

  return layoutConfiguration;
}
